import { EventEmitter } from 'eventemitter3';
export class SSAIManager extends EventEmitter {
}
